import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function addWorkerFailure(draft: Draft<IInterventionData>) {
  draft.addWorker.config.isLoading = false;
}

export default addWorkerFailure;
